(function(){
    angular.module('tmx-app').directive("tmxReport",  ['APP_CONSTANTS',tmxReport]);
    function tmxReport(APP_CONSTANTS) {
        return{
            restrict: 'E',
            scope: {
                reportName: "@",
                paramsTimeFrames:"="

            },
            link: function(scope, element) {
                //var clearSelection = false;
                element
                    .telerik_ReportViewer({
                        // The URL of the Telerik Reporting REST service which will serve reports.
                        serviceUrl: APP_CONSTANTS.backReport,
                        templateUrl: 'lib/ReportViewer/templates/telerikReportViewerTemplate.html',
                        //ReportSource - report description
                        reportSource: {
                            // The report can be set to a report file name (trdx report definition)
                            // or CLR type name (report class definition).
                            report: scope.reportName,
                            parameters: {
                                CultureID: "en"
                            }
                        },
                        // Specifies whether the viewer is in interactive or print preview mode.
                        // PRINT_PREVIEW - Displays the paginated report as if it is printed on paper. Interactivity is not enabled.
                        // INTERACTIVE - Displays the report in its original width and height without paging. Additionally interactivity is enabled.
                        viewMode: telerikReportViewer.ViewModes.INTERACTIVE,

                        // Sets the scale mode of the viewer.
                        // Three modes exist currently:
                        // FIT_PAGE - The whole report will fit on the page (will zoom in or out), regardless of its width and height.
                        // FIT_PAGE_WIDTH - The report will be zoomed in or out so that the width of the screen and the width of the report match.
                        // SPECIFIC - Uses the scale to zoom in and out the report.
                        scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,

                        // Zoom in and out the report using the scale
                        // 1.0 is equal to 100%, i.e. the original size of the report
                        scale: 1.0,
                        parameterEditors: [
                            {

                                match: function (parameter) {

                                    return Boolean(parameter.availableValues) && parameter.multivalue &&
                                           parameter.type === "System.String" && parameter.name==="ParamBDOName";
                                },
                                createEditor: function (placeholder, options) {
                                     

                                    var dropDownElement = $(placeholder).html('<select id="BDOName"></select>');
                                    var autoComplete = $(dropDownElement).find("#BDOName");
                                    var parameter,
                                        valueChangedCallback = options.parameterChanged,
                                        dropDownGrid;

                                    function onChange() {
                                         
                                        //clearSelection = !clearSelection;
                                        var val = dropDownGrid.value();
                                        valueChangedCallback(parameter, val);
                                    }
                                     // create MultiSelect from select HTML element
                                    function contains(value, values) {
                                        for (var idx = 0; idx < values.length; idx++) {
                                            if (values[idx] === value) {
                                                return true;
                                            }
                                        }

                                        return false;
                                    }
                                    function dynamicSort(property) {
                                        var sortOrder = 1;
                                        if(property[0] === "-") {
                                            sortOrder = -1;
                                            property = property.substr(1);
                                        }
                                        return function (a,b) {
                                            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                                            return result * sortOrder;
                                        }
                                    }

                                    ///////////////////////////////////////////////////////////////////////////////////
                                    return {
                                        beginEdit: function (param) {
                                           
                                            parameter = param;
                                            var array = [];
                                            var values = parameter.availableValues.slice(1);

                                            values.sort(dynamicSort("name"));//sorting alphabetically
                                            values.unshift(parameter.availableValues[0]);
                                            parameter.availableValues = angular.copy(values);

                                            $(autoComplete).kendoMultiSelect({
                                                value: parameter.value,
                                                dataSource: parameter.availableValues,
                                                dataTextField: "name",
                                                dataValueField: "value",
                                                //AutoBind:false,
                                                change: onChange,
                                                select: function(e) {
                                                    var values = this.value();
                                                    var dataItemValue = this.dataSource.view()[e.item.index()].value;
                                                    if (dataItemValue === "select-all" ||
                                                        dataItemValue !== "select-all" && contains(dataItemValue, values)
                                                    ) {

                                                        values = [];
                                                        values.push(dataItemValue);
                                                        dropDownGrid.value(values);
                                                        dropDownGrid.trigger("change"); //notify others for the updated values
                                                        e.preventDefault();
                                                    }
                                                    else{
                                                        return;
                                                    }


                                                //    for(var i=0;i<this.dataSource.view().length;i++){
                                                //        var dataItemValue = this.dataSource.view()[i].value;
                                                //        if (dataItemValue === "select-all") {
                                                //            values = [];
                                                //            values.push(dataItemValue);
                                                //        }
                                                //    }
                                                //
                                                //
                                                //

                                                //    //
                                                //    //if (dataItemValue === "select-all") {
                                                //    //    values = [];
                                                //    //    //this.value("");
                                                //    //} else if (values.indexOf("select-all") !== -1) {
                                                //    //    values = $.grep(values, function(value) {
                                                //    //        return value !== "select-all";
                                                //    //    });
                                                //    //}
                                                //
                                                //
                                                //    dropDownGrid.value(values);

                                                }
                                            });

                                            dropDownGrid = $(autoComplete).data("kendoMultiSelect");


                                        }

                                    };
                                }//create editor function end
                            }
                        ]

                    });
            }

        };//return end
    }//function end
})();